(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.getElementById("sticky-atc");
  const mainATC = document.querySelector('[data-type="add-to-cart-form"]');

  if (!stickyBar || !mainATC) return;

  // Show / hide based on main Add to Cart visibility
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.classList.remove("show");
      } else {
        stickyBar.classList.add("show");
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainATC);

  // Sync variant selection
  document.addEventListener("change", function (e) {
    if (e.target.name === "id") {
      const stickyInput = document.getElementById("StickyVariantId");
      if (stickyInput) {
        stickyInput.value = e.target.value;
      }
    }
  });

  // Sync price
  document.addEventListener("variant:change", function (e) {
    if (!e.detail || !e.detail.variant) return;
    const priceEl = document.getElementById("sticky-price");
    if (priceEl) {
      priceEl.innerText = e.detail.variant.price / 100
        ? Shopify.formatMoney(e.detail.variant.price)
        : priceEl.innerText;
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-template"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-atc');
  const mainATC = document.querySelector('[data-type="add-to-cart-form"]');

  if (!stickyBar || !mainATC) return;

  const stickyForm = stickyBar.querySelector('form');
  const stickyInput = document.getElementById('StickyVariantId');

  const mainProductForm = mainATC.closest('product-form') || document.querySelector('product-form');
  const mainForm = mainProductForm ? mainProductForm.querySelector('form') : null;
  const mainVariantInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
  const mainQtyInput = mainForm ? mainForm.querySelector('input[name="quantity"]') : null;
  const mainSubmitButton = mainForm
    ? mainForm.querySelector('button[type="submit"], button[name="add"]')
    : null;

  if (!stickyForm || !mainForm || !mainSubmitButton) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('show');
      } else {
        stickyBar.classList.add('show');
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainATC);

  document.addEventListener('change', function (e) {
    if (e.target.name === 'id' && stickyInput) {
      stickyInput.value = e.target.value;
    }
  });

  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;

    const priceEl = document.getElementById('sticky-price');
    if (priceEl && window.Shopify && typeof Shopify.formatMoney === 'function') {
      priceEl.innerText = Shopify.formatMoney(e.detail.variant.price);
    }
  });

  stickyForm.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (stickyInput && mainVariantInput) {
      mainVariantInput.value = stickyInput.value;
      mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const stickyQtyInput = stickyForm.querySelector('input[name="quantity"]');
    if (stickyQtyInput && mainQtyInput) {
      mainQtyInput.value = stickyQtyInput.value;
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    mainSubmitButton.click();
  }, true);
});

  } catch(e) { console.error(e); }
})();
})();
